module.exports = __webpack_public_path__ + "static/media/214.0155dd40.webp";